<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_sy4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('paymentRecords_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('paymentRecords_batchRead_button')"
          @click="setMultipleRead"
        >
          批量标记已读
        </el-button>
        <el-button
          v-if="getLimit('paymentRecords_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="orderDetailNumber"
          title="运输单号"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="driverName"
          title="实际承运人姓名"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="driverPhone"
          title="手机号"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="200"
          field="deliveryFeeDeserved"
          title="应收运费"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.deliveryFeeDeservedStart"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('deliveryFeeDeservedStart')"
            />
            <el-input
              v-model="listQuery.deliveryFeeDeservedEnd"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('deliveryFeeDeservedEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="200"
          field="deliveryFeePractical"
          title="实收运费"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.deliveryFeePracticalStart"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('deliveryFeePracticalStart')"
            />
            <el-input
              v-model="listQuery.deliveryFeePracticalEnd"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('deliveryFeePracticalEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="200"
          field="deliveryOilFee"
          title="分配油卡"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.deliveryOilFeeStart"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('deliveryOilFeeStart')"
            />
            <el-input
              v-model="listQuery.deliveryOilFeeEnd"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('deliveryOilFeeEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="200"
          field="deliveryCashFee"
          title="实收现金"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.deliveryCashFeeStart"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('deliveryCashFeeStart')"
            />
            <el-input
              v-model="listQuery.deliveryCashFeeEnd"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('deliveryCashFeeEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          width="200"
          field="extraFee"
          title="其他费用"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.extraFeeStart"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('extraFeeStart')"
            />
            <el-input
              v-model="listQuery.extraFeeEnd"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('extraFeeEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="isRead"
          title="是否已读"
          :formatter="formatterCommonStatus"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isRead" clearable placeholder="请选择">
            <el-option
              v-for="item in commonStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="320"
          field="gmtCreated"
          title="创建日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          width="320"
          field="gmtModified"
          title="更新日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="60" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('paymentRecords_read_button') && scope.row.isRead === 0
            "
            class="item"
            effect="dark"
            content="标记已读"
            placement="top"
          >
            <vxe-button type="text" @click="setSingleRead(scope.row.code)">
              <i class="el-icon-folder" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-else-if="
              getLimit('paymentRecords_readed_button') && scope.row.isRead != 0
            "
            class="item"
            effect="dark"
            content="已读"
            placement="top"
          >
            <vxe-button type="text">
              <i class="el-icon-folder-opened" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import {
  getPaymentRecordsList,
  updateReadStatus,
  updateCheckedReadStatus
} from "@/api/news";
import { isNumber } from "@/utils/validate.js";
export default {
  name: "PaymentRecordsList",
  data() {
    return {
      loading: false,
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/urgeRemit/exportUrgeRemit", //导出接口
        name: "实际承运人催款记录"
      },
      listQuery: {
        gmtModifiedRange: "",
        gmtCreatedRange: "",
        orderDetailNumber: "",
        driverName: "",
        driverPhone: "",
        deliveryFeeDeserved: "",
        deliveryFeePractical: "",
        deliveryOilFee: "",
        deliveryCashFee: "",
        extraFee: "",
        isRead: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        gmtModifiedStart: "",
        gmtModifiedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 通用是否状态
      commonStatusList: [
        { label: "未读", value: 0 },
        { label: "已读", value: 1 }
      ],
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.isRead = 0;
      } else {
        this.listQuery.isRead = "";
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.isRead = 0;
    }
    this.findList();
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    // 列表
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getPaymentRecordsList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 标记单项已读
    setSingleRead(code) {
      this.$confirm("确认标记已读吗？").then(_ => {
        updateReadStatus({ isRead: 1, code }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 标记多项已读
    setMultipleRead() {
      const checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({ message: "请选择需要批量标记的项目", type: "warning" });
        return false;
      }
      const isReadArray = checkedRowArray.filter(item => item.isRead === 1);
      if (isReadArray.length) {
        this.$message({ message: "已读消息请勿重复标记", type: "warning" });
        return false;
      }
      this.$refs.xTable.clearCheckboxRow();
      const codes = checkedRowArray.map(item => item.code).join(",");
      updateCheckedReadStatus({ isRead: 1, codes }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style></style>
